/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const ModalitaContattoCountDtoModalitaEnum = {
    Mail: 'MAIL',
    Telefono: 'TELEFONO',
    Incontro: 'INCONTRO'
};
/**
 * Check if a given object implements the ModalitaContattoCountDto interface.
 */
export function instanceOfModalitaContattoCountDto(value) {
    return true;
}
export function ModalitaContattoCountDtoFromJSON(json) {
    return ModalitaContattoCountDtoFromJSONTyped(json, false);
}
export function ModalitaContattoCountDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'modalita': json['modalita'] == null ? undefined : json['modalita'],
        'count': json['count'] == null ? undefined : json['count'],
    };
}
export function ModalitaContattoCountDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'modalita': value['modalita'],
        'count': value['count'],
    };
}
